import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import { Nav, Tab } from "react-bootstrap";
import Use_Of_Reference_Material from "./inner_tab_reports/use_of_reference_material/Use_Of_Reference_Material";
import Use_Of_Alternative_Instrument from "./inner_tab_reports/use_of_alternative_instrument/Use_Of_Alternative_Instrument";
import Replicate_Testing from "./inner_tab_reports/replicate_testing/Replicate_Testing";
import Retesting_Testing from "./inner_tab_reports/retesting_testing/Retesting_Testing";
import Blind_Sample from "./inner_tab_reports/blind_sample/Blind_Sample";
import ILC from "./inner_tab_reports/ilc/ILC";
import PT_Report from "./inner_tab_reports/pt_report/PT_Report";

const Ensuring_Validity_Of_Result = () => {
  const [show, setShow] = useState(false);

  const tabs = [
    "Use Of Reference Material",
    "Use Of Alternative Instrument",
    "Replicate Testing",
    "Retesting Testing",
    "Blind Sample",
    "ILC",
    "PT",
  ];

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Ensuring Validity Of Result" />
      </div>

      <div className="tables_tab_section">
        <Tab.Container id="left-tabs-example" defaultActiveKey={tabs[0]}>
          <Nav variant="pills" className="">
            {tabs?.map((item) => {
              return (
                <Nav.Item>
                  <Nav.Link eventKey={item}>{item}</Nav.Link>
                </Nav.Item>
              );
            })}
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Use Of Reference Material">
              <Use_Of_Reference_Material />
            </Tab.Pane>

            <Tab.Pane eventKey="Use Of Alternative Instrument">
              <Use_Of_Alternative_Instrument />
            </Tab.Pane>

            <Tab.Pane eventKey="Replicate Testing">
              <Replicate_Testing />
            </Tab.Pane>

            <Tab.Pane eventKey="Retesting Testing">
              <Retesting_Testing />
            </Tab.Pane>

            <Tab.Pane eventKey="Blind Sample">
              <Blind_Sample />
            </Tab.Pane>

            <Tab.Pane eventKey="ILC">
              <ILC />
            </Tab.Pane>

            <Tab.Pane eventKey="PT">
              <PT_Report />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>

      <Common_Report_Offcanvas
        title={"Resource Requirement"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Ensuring_Validity_Of_Result;
